import { OptimizedImage } from '@/components/images';
import { cn } from '@/lib/ui/utils';
import './app-upsells.css';

export function AppPhone({
  className,
  priority = false,
}: {
  className?: string;
  priority?: boolean;
}): React.ReactNode {
  return (
    <div className={cn('app-upsell-phone', className)} aria-hidden="true">
      <div className={'app-upsell-screen'}>
        <OptimizedImage
          variant="hero"
          src="/images/app-upsells/market-screen.png"
          alt=""
          sizes="240px"
          priority={priority}
          preview={false} // ALLOW-NO-PREVIEW: decorative app promotion artwork, not user-uploaded media
          // ALLOW-NSFW-FALSE: reviewed first-party app artwork, not user-uploaded media
          nsfw={false}
          loadReveal="none"
        />
      </div>
    </div>
  );
}
